// extracted by css-extract-rspack-plugin
export default {"cartItem":"cart-item--fBB_YQWXsU7JmQ6R","hideLastDivider":"hide-last-divider--C4qo7xAB64ZF6Whn","giftWrapper":"gift-wrapper--_beX4E18A9ZItBAu"};